import axios from 'axios'
export const uni = Object.create(null)
uni.request=axios

